import script from "./AppModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AppModal.vue?vue&type=script&setup=true&lang=js"

import "./AppModal.vue?vue&type=style&index=0&id=5b4943da&lang=scss&scoped=true"

import exportComponent from "/Users/chronosme/Domains/mathgs2.mu/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5b4943da"]])

export default __exports__